import React from 'react';
import PropTypes from 'prop-types';
import { regionFrance, guadeloupe, martinique, reunion } from "../utils/geojson";

export class RegionSelect extends React.Component {

    constructor(props) {
        super(props);
        const regions = regionFrance.geoJson.features.map(feature => { return { code: feature.properties.code, nom: feature.properties.nom}; })
            .concat([{code: guadeloupe.geoJson.properties.code, nom: guadeloupe.geoJson.properties.nom }])
            .concat([{code: martinique.geoJson.properties.code, nom: martinique.geoJson.properties.nom }])
            .concat([{code: reunion.geoJson.properties.code, nom: reunion.geoJson.properties.nom }])
            .sort((a,b) => a.nom.localeCompare(b.nom));
        this.state = {
            regions
        }
        this.clickOnRegion = this.clickOnRegion.bind(this)
        this.applyRegionChange = this.applyRegionChange.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        // Reset selection whenever display status changes
        if (nextProps.show && this.props.show !== nextProps.show) {
            this.setState({
                regionSelected: undefined,
                showError: false
            })
        }
        // Reset error whenever region is changed externally
        if (nextProps.regionSelected !== this.props.regionSelected) {
            this.setState({showError: false});
        }
    }

    clickOnRegion(e) {
        this.setState({regionSelected: e.target.value, showError: false})
    }

    applyRegionChange(e) {
        if (this.props.clickOnRegion) {
            let idRegion = this.state.regionSelected;
            if (idRegion) {
                let regionName = this.state.regions.find(region => region.code === idRegion).nom;
                this.props.clickOnRegion(idRegion, regionName);
            } else {
                this.setState({showError: true}, () => this._selectNode.focus());
            }
        }
    }

    render() {
        return (
            <div className={`france-select${this.props.show ? '' : ' unvisible'}`}>
                <div className={`form-group ${this.state.showError ? 'has-error' : ''}`}>
                    <label htmlFor="field-error" for="general-selector-region">Sélectionnez une région</label>
                    <div className="general-selector-container">
                        <div className="field-item" id={`${this.state.showError ? 'field-error' : ''}`}>
                            <select id="general-selector-region" className="general-selector" value={this.state.regionSelected || ''} onChange={this.clickOnRegion} aria-required={true} aria-invalid={this.state.showError} aria-describedby={`${this.state.showError ? 'error-region-msg' : ''}`} ref={ (node) => {this._selectNode = node} }>
                                <option value="">Sélectionnez une région</option>
                                {this.state.regions.map(region => <option key={region.code} value={region.code}>{region.nom}</option>)}
                            </select>
                            <button onClick={this.applyRegionChange}>Valider</button>
                        </div>
                        {this.state.showError && <p className="help-block" id="error-region-msg">Veuillez sélectionner une région dans la liste.</p>}
                    </div>
                </div>
            </div>
        )
    }
}

RegionSelect.propTypes = {
    clickOnRegion: PropTypes.func,
    show: PropTypes.bool
}

RegionSelect.defaultProps = {
    show: true
}